import InvoiceDetails from "@/components/contributor/InvoiceDetails";
import InvoiceSkeleton from "@/components/skeleton/InvoiceSkeleton";
import { STALE_TIME_INVOICE } from "@/constants";
import { ContributorPerson, useAuth } from "@/context/Auth/CombinedAuthContext";
import { getSingleMasterContributorInvoice } from "@/services/external-contributors-functions";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

const MyInvoice = () => {
	const { id } = useParams<{ id: string }>() as { id: string };
	const user = useAuth().person as ContributorPerson;

	const invoice = useQuery({
		queryKey: ["master-invoice", id],
		queryFn: () => getSingleMasterContributorInvoice(user?.accessToken!, id),
		staleTime: STALE_TIME_INVOICE,
		enabled: !!user?.accessToken,
	});

	// const canEdit = (invoice: Invoice) => {
	// 	if (invoice.financeamend) return true;
	// 	if (invoice.manageramend) return true;
	// 	if (!invoice.managerapproved && !invoice.managerrejected) return true;
	// 	return false;
	// };

	return (
		<div>
			{invoice.isLoading ? (
				<InvoiceSkeleton />
			) : invoice.isError ? (
				<div className="align-centre">
					<h5 className="text-center">Error loading claim.</h5>
				</div>
			) : (
				invoice.data && (
					<>
						<div className="flex gap-3 items-end justify-between mb-2">
							<h1 className="font-medium text-4xl">
								CLAIM NO: {invoice.data.invoicemasterid}
							</h1>
							{/* {canEdit(invoice.data) ? (
                                <EditClaimHolder invoice={invoice.data} />
                            ) : null} */}
						</div>
						<InvoiceDetails invoice={invoice.data} accessToken={user.accessToken} />
					</>
				)
			)}
		</div>
	);
};

export default MyInvoice;
